import * as React from 'react';
import { useSelector } from 'react-redux';
import { PriceBlock as PriceBlockComponent } from '../../components/PriceBlock';
import { PriceRelevance } from '../PriceRelevance';
import { CallButton } from '../CallButton';
import { SinglePhone } from '../SinglePhone';
import { trackOpenContacts, trackShowPhone } from '../../analytics/call';
import {
  hasContactsSelector,
  priceRelevanceSelector,
  priceForObjectSelector,
  priceForMeterSelector,
  gaLabelSelector,
} from '../../selectors/newbuilding';

export const PriceBlock = () => {
  const priceForObject = useSelector(priceForObjectSelector);
  const priceForMeter = useSelector(priceForMeterSelector);
  const hasPriceRelevance = !!useSelector(priceRelevanceSelector);
  const hasContacts = useSelector(hasContactsSelector);
  const gaLabel = useSelector(gaLabelSelector);

  const isPriceBlockShown = React.useMemo(() => {
    return priceForObject || priceForMeter || hasPriceRelevance || hasContacts;
  }, [priceForObject, priceForMeter, hasPriceRelevance, hasContacts]);

  const handleOpenContacts = React.useCallback(() => {
    trackOpenContacts(gaLabel);
  }, [gaLabel]);

  const handleShowPhone = React.useCallback(() => {
    trackShowPhone('Open_jk_card_blockJK', gaLabel);
  }, [gaLabel]);

  if (!isPriceBlockShown) {
    return null;
  }

  return (
    <PriceBlockComponent
      priceRelevance={<PriceRelevance />}
      callButton={
        <CallButton
          placeType="blockStickyRightTop"
          onShowPhoneClick={handleShowPhone}
          onOpenContactsClick={handleOpenContacts}
          SinglePhoneComponent={SinglePhone}
        />
      }
      priceForObject={priceForObject}
      priceForMeter={priceForMeter}
      hasContacts={hasContacts}
    />
  );
};
